import styled from 'styled-components';
import { zeroWidthNonBreakingSpace } from '../../../../../../../generic/utilities/zero-width-space';
import { useImpactChartWidths } from '../../context';
import { grayBorder } from '../../shared';

export function BackLine() {
  const widths = useImpactChartWidths();
  const x = widths.title + widths.bars + widths.middle / 2;
  return <LineRoot style={{ left: x }}>{zeroWidthNonBreakingSpace}</LineRoot>;
}

const LineRoot = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: ${grayBorder};
`;
